<template>
  <footer class="footer has-cards">
    <div class="container">
      <div class="row row-grid align-items-center my-md">
        <div class="col-lg-6">
          <h3 class="text-primary font-weight-light mb-2">{{$t('Thank_You_For_Supporting_Us')}}!</h3>
          <p class="mb-0 font-weight-light">{{$t('Footer_Info')}}.</p>
        </div>
        <div class="col-lg-6 text-lg-center btn-wrapper">
          <a
            target="_blank"
            rel="noopener"
            href="https://www.twitter.com/"
            class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Follow us"
          >
            <i class="fa fa-twitter"></i>
          </a>
          <a
            target="_blank"
            rel="noopener"
            href="https://www.facebook.com/"
            class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Like us"
          >
            <i class="fa fa-facebook-square"></i>
          </a>
          <a
            target="_blank"
            rel="noopener"
            href="https://www.instagram.com/"
            class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round"
            data-toggle="tooltip"
            data-original-title="Follow us"
          >
            <i class="fa fa-instagram"></i>
          </a>
          <!-- <a target="_blank" rel="noopener" href="#."
                       class="btn btn-danger btn-icon-only btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Star on Github">
                        <i class="fa fa-google-plus"></i>
          </a>-->
        </div>
      </div>
      <hr />
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-5">
          <div class="copyright">
            &copy; {{year}}
            <a href="#" target="_self" rel="noopener">{{$t('Copy_Write_Info')}}</a>
          </div>
        </div>
        <div class="col-md-7">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item">
              <a href="#" class="nav-link" target="_self" rel="noopener">{{$t('Terms_Of_Use')}}</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link" target="_self" rel="noopener">{{$t('Privacy_Policy')}}</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link" target="_self" rel="noopener">{{$t('Support')}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
</style>
